import type {
  ElementType,
  HTMLProps,
  MouseEventHandler,
  ReactNode,
} from 'react'
import React from 'react'

import classnames from 'classnames'

import type { LinkAppearance } from '../../../types'
import type { LinkStyleText } from '../../Link/Link'
import { Link } from '../../Link/Link'
import styles from './NavigationLink.module.scss'

export const NavigationLink: React.FunctionComponent<Props> = ({
  href = '',
  children,
  linkStyle = 'primary',
  textStyle,
  icon: Icon,
  includeIcon = true,
  className,
  clickHandler,
  ...rest
}) => {
  const IconComponent = Icon || undefined

  return (
    <Link
      href={href}
      appearance={linkStyle}
      textStyle={textStyle}
      className={classnames(styles.navigationLink, className)}
      data-testid="navigation-link"
      includeIcon={includeIcon}
      icon={IconComponent}
      {...(clickHandler && { onClick: clickHandler })}
      {...rest}
    >
      {children}
    </Link>
  )
}

///////// IMPLEMENTATION /////////

type Props = {
  children: ReactNode
  href?: string | null
  linkStyle?: LinkAppearance
  textStyle?: LinkStyleText
  icon?: ElementType
  includeIcon?: boolean
  className?: string
  clickHandler?: MouseEventHandler<HTMLAnchorElement>
  [key: `data-${string}`]: string | undefined
} & HTMLProps<HTMLAnchorElement>
